import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Badge, Button, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import api, { getMediaUrl } from '../services/api';

const Projects = () => {
    const [projectList, setProjectList] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProjects = async () => {
            try {
                const response = await api.get('/projects/');
                const data = response.data.results || response.data;
                if (Array.isArray(data)) {
                    setProjectList(data);
                } else {
                    setProjectList([]);
                }
            } catch (error) {
                console.error('Error fetching projects:', error);
                setProjectList([]);
            } finally {
                setLoading(false);
            }
        };

        fetchProjects();
    }, []);

    const getStatusColor = (status) => {
        switch (status) {
            case 'ongoing': return 'warning';
            case 'completed': return 'success';
            case 'planned': return 'primary';
            case 'on_hold': return 'danger';
            default: return 'secondary';
        }
    };

    if (loading) {
        return (
            <Container className="py-5 text-center">
                <Spinner animation="border" variant="primary" />
            </Container>
        );
    }

    return (
        <Container className="py-5">
            <div className="admin-header mb-4">
                <h1>Ongoing & Completed Projects</h1>
                <p className="text-muted">Tracking infrastructure and development across the city</p>
            </div>

            <Row>
                {Array.isArray(projectList) && projectList.map((project) => (
                    <Col key={project.id} lg={4} md={6} className="mb-4">
                        <Card className="h-100 shadow-sm border-0 project-page-card">
                            <div style={{ height: '200px', overflow: 'hidden', position: 'relative' }}>
                                {project.image ? (
                                    <Card.Img
                                        variant="top"
                                        src={getMediaUrl(project.image)}
                                        style={{ height: '100%', objectFit: 'cover' }}
                                    />
                                ) : (
                                    <div className="bg-light d-flex align-items-center justify-content-center h-100">
                                        <i className="fas fa-building fa-3x text-muted"></i>
                                    </div>
                                )}
                                <Badge
                                    bg={getStatusColor(project.status)}
                                    className="position-absolute"
                                    style={{ top: '10px', right: '10px' }}
                                >
                                    {project.status.toUpperCase().replace('_', ' ')}
                                </Badge>
                            </div>
                            <Card.Body className="d-flex flex-column">
                                <Card.Title className="fw-bold">{project.title}</Card.Title>
                                <Card.Text className="text-muted small mb-3">
                                    {project.summary}
                                </Card.Text>
                                {project.location && (
                                    <div className="small mb-2 text-primary">
                                        <i className="fas fa-map-marker-alt me-1"></i> {project.location}
                                    </div>
                                )}
                                <div className="mt-auto">
                                    <Link to={`/projects/${project.slug}`}>
                                        <Button variant="outline-primary" size="sm" className="w-100">
                                            View Details
                                        </Button>
                                    </Link>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
                {(!Array.isArray(projectList) || projectList.length === 0) && (
                    <Col className="text-center py-5">
                        <h3>No projects found</h3>
                        <p>Check back later for updates on city development.</p>
                    </Col>
                )}
            </Row>
        </Container>
    );
};

export default Projects;
